'use client'

import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'
import { useUser } from '@clerk/nextjs'

export default function PostHogIdentify() {
  const posthog = usePostHog()
  const { user, isLoaded } = useUser()

  useEffect(() => {
    if (posthog && isLoaded && user) {
      posthog.identify(user.id, {
        email: user.primaryEmailAddress?.emailAddress,
        name: user.fullName
      })
    } else if (posthog && isLoaded && !user) {
        posthog.reset()
    }
  }, [posthog, user, isLoaded])

  return null
}
